import { render, staticRenderFns } from "./index_stb.vue?vue&type=template&id=6faa7f14&scoped=true"
import script from "./index_stb.vue?vue&type=script&lang=js"
export * from "./index_stb.vue?vue&type=script&lang=js"
import style0 from "./index_stb.vue?vue&type=style&index=0&id=6faa7f14&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa7f14",
  null
  
)

export default component.exports